import React, { createContext, useState, useEffect, ReactNode, useContext } from 'react';

interface AuthContextType {
  isAuthenticated: boolean;
  authenticate: (email: string, password: string) => any;
  logout: () => void;
}

interface AuthProviderProps {
  children: ReactNode;
  navigate: (path: string) => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

const AuthProvider: React.FC<AuthProviderProps> = ({ children, navigate }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const expirationTime = 30 * 60 * 1000; // 30 minutes in milliseconds

  useEffect(() => {
    const savedLoginTime = localStorage.getItem('loginTime');
    if (savedLoginTime) {
      const timeElapsed = Date.now() - parseInt(savedLoginTime, 10);
      if (timeElapsed < expirationTime) {
        setIsAuthenticated(true);
      } else {
        localStorage.removeItem('loginTime');
        navigate('/digitalarchiving'); // Redirect to login when session expires
      }
    }
  }, []);

  const authenticate = async (email: string, password: string) => {

    return await handleLogin(email, password);
    // if (password === correctPassword) {
    //   setIsAuthenticated(true);
    //   localStorage.setItem('loginTime', Date.now().toString());
    //   navigate(savedPath); // Redirect to the last visited page or default to "/"
    //   return true;
    // }
    // return false;
  };

  const handleLogin = async (email: string, password: string) => {
  
    const response = await fetch("https://www.theprojectgenesis.net/api/login", { // https://theprojectgenesis.net
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password }),
    });
  
    if (response.ok) {
      const { token, user } = await response.json();
      localStorage.setItem("authToken", token); // Save the token to localStorage

      setIsAuthenticated(true);
      localStorage.setItem('loginTime', Date.now().toString());
      const savedPath = '/dashboard';
      if (user.role == 'admin') navigate('/users')
      else navigate(savedPath); // Redirect to the last visited page or default to "/"
      
      return { success: true }
    } else {
      const error = await response.json();
      return { success: false, message: error.error};
    }
  };

  const logout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem('loginTime');
    navigate('/digitalarchiving'); // Redirect to login page
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, authenticate, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within an AuthProvider');
  return context;
};

export default AuthProvider;
